import axios from 'axios';

export const openApiInstances = {
  Quote: axios.create(),
  Config: axios.create(),
  Trip: axios.create(),
};
